(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rabitat-celebrities"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousels = document.querySelectorAll('[data-celebrities-carousel]');

    carousels.forEach((carousel) => {
      const viewport = carousel.querySelector('.rabitat-celebrities__viewport');
      const track = carousel.querySelector('.rabitat-celebrities__track');
      const cards = carousel.querySelectorAll('[data-celebrities-card]');
      const prevBtn = carousel.querySelector('[data-celebrities-prev]');
      const nextBtn = carousel.querySelector('[data-celebrities-next]');

      if (!viewport || !track || cards.length <= 1) return;

      let currentIndex = 0;

      const getSlidesPerView = () => (window.innerWidth <= 768 ? 1 : 3);

      const getMaxIndex = () => Math.max(0, cards.length - getSlidesPerView());

      const updateButtons = () => {
        if (prevBtn) prevBtn.disabled = currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= getMaxIndex();
      };

      const scrollToIndex = (index) => {
        currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
        const card = cards[currentIndex];

        if (card) {
          viewport.scrollTo({
            left: card.offsetLeft - track.offsetLeft,
            behavior: 'smooth',
          });
        }

        updateButtons();
      };

      if (prevBtn) prevBtn.addEventListener('click', () => scrollToIndex(currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollToIndex(currentIndex + 1));

      let scrollTicking = false;

      viewport.addEventListener(
        'scroll',
        () => {
          if (scrollTicking) return;
          scrollTicking = true;
          window.requestAnimationFrame(() => {
            scrollTicking = false;
            const scrollLeft = viewport.scrollLeft;
            let nearestIndex = 0;
            let nearestDistance = Infinity;

            cards.forEach((card, index) => {
              const distance = Math.abs(card.offsetLeft - track.offsetLeft - scrollLeft);
              if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
              }
            });

            currentIndex = Math.min(nearestIndex, getMaxIndex());
            updateButtons();
          });
        },
        { passive: true }
      );

      window.addEventListener('resize', updateButtons, { passive: true });
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rabitat-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function padSlideNumber(value) {
      return String(value).padStart(2, '0');
    }

    function initHeroSlider(slider) {
      if (slider.dataset.heroSliderBound === 'true') return;
      slider.dataset.heroSliderBound = 'true';

      const slides = slider.querySelectorAll('[data-hero-slide]');
      const prevBtn = slider.querySelector('[data-hero-prev]');
      const nextBtn = slider.querySelector('[data-hero-next]');
      const dots = slider.querySelectorAll('[data-hero-dot]');
      const counterCurrent = slider.querySelector('[data-hero-counter-current]');
      const counterTotal = slider.querySelector('[data-hero-counter-total]');
      const autoplay = slider.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const pauseOnHover = slider.dataset.pauseOnHover === 'true';
      const speed = (parseInt(slider.dataset.autoplaySpeed, 10) || 5) * 1000;
      let current = 0;
      let timer = null;

      if (slides.length <= 1) return;

      const updateControls = () => {
        dots.forEach((dot, index) => {
          const isActive = index === current;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        if (counterCurrent) {
          counterCurrent.textContent = padSlideNumber(current + 1);
        }
      };

      if (counterTotal) {
        counterTotal.textContent = padSlideNumber(slides.length);
      }

      const goTo = (index) => {
        slides[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        updateControls();
      };

      const next = () => goTo(current + 1);
      const prev = () => goTo(current - 1);

      const restartAutoplay = () => {
        stopAutoplay();
        startAutoplay();
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          prev();
          restartAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          next();
          restartAutoplay();
        });
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          goTo(parseInt(dot.dataset.heroDot, 10));
          restartAutoplay();
        });
      });

      const viewport = slider.querySelector('.rabitat-hero-slider__viewport') || slider;

      if (window.initRabitatSliderTouch) {
        window.initRabitatSliderTouch(viewport, {
          onNext: () => {
            next();
            restartAutoplay();
          },
          onPrev: () => {
            prev();
            restartAutoplay();
          },
        });
      }

      const startAutoplay = () => {
        if (!autoplay) return;
        stopAutoplay();
        timer = window.setInterval(next, speed);
      };

      const stopAutoplay = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      if (pauseOnHover) {
        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', startAutoplay);
      }

      updateControls();
      startAutoplay();
    }

    document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rabitat-launches"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sliders = document.querySelectorAll('[data-launches-slider]');

    sliders.forEach((slider) => {
      const slides = slider.querySelectorAll('[data-launches-slide]');
      const prevBtn = slider.querySelector('[data-launches-prev]');
      const nextBtn = slider.querySelector('[data-launches-next]');
      const dots = slider.querySelectorAll('[data-launches-dot]');
      const autoplay = slider.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const speed = (parseInt(slider.dataset.autoplaySpeed, 10) || 6) * 1000;
      let current = 0;
      let timer = null;

      if (slides.length <= 1) return;

      const updateDots = () => {
        dots.forEach((dot, index) => {
          const isActive = index === current;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const goTo = (index) => {
        slides[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        updateDots();
      };

      const next = () => goTo(current + 1);
      const prev = () => goTo(current - 1);

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          prev();
          stopAutoplay();
          startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          next();
          stopAutoplay();
          startAutoplay();
        });
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(parseInt(dot.dataset.launchesDot, 10));
          stopAutoplay();
          startAutoplay();
        });
      });

      const viewport = slider.querySelector('.rabitat-launches__viewport') || slider;

      if (window.initRabitatSliderTouch) {
        window.initRabitatSliderTouch(viewport, {
          onNext: () => {
            next();
            stopAutoplay();
            startAutoplay();
          },
          onPrev: () => {
            prev();
            stopAutoplay();
            startAutoplay();
          },
        });
      }

      const startAutoplay = () => {
        if (!autoplay) return;
        stopAutoplay();
        timer = window.setInterval(next, speed);
      };

      const stopAutoplay = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);

      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rabitat-press"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousels = document.querySelectorAll('[data-press-carousel]');

    carousels.forEach((carousel) => {
      const viewport = carousel.querySelector('.rabitat-press__viewport');
      const track = carousel.querySelector('.rabitat-press__grid');
      const items = carousel.querySelectorAll('[data-press-item]');
      const prevBtn = carousel.querySelector('[data-press-prev]');
      const nextBtn = carousel.querySelector('[data-press-next]');

      if (!viewport || !track || items.length <= 1) return;

      let currentIndex = 0;

      const isMobile = () => window.innerWidth <= 768;

      const getMaxIndex = () => (isMobile() ? items.length - 1 : 0);

      const updateButtons = () => {
        if (!isMobile()) {
          if (prevBtn) prevBtn.disabled = false;
          if (nextBtn) nextBtn.disabled = false;
          return;
        }

        if (prevBtn) prevBtn.disabled = currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= getMaxIndex();
      };

      const scrollToIndex = (index) => {
        if (!isMobile()) return;

        currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
        const item = items[currentIndex];

        if (item) {
          viewport.scrollTo({
            left: item.offsetLeft - track.offsetLeft,
            behavior: 'smooth',
          });
        }

        updateButtons();
      };

      if (prevBtn) prevBtn.addEventListener('click', () => scrollToIndex(currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollToIndex(currentIndex + 1));

      let scrollTicking = false;

      viewport.addEventListener(
        'scroll',
        () => {
          if (!isMobile()) return;
          if (scrollTicking) return;
          scrollTicking = true;

          window.requestAnimationFrame(() => {
            scrollTicking = false;
            const scrollLeft = viewport.scrollLeft;
            let nearestIndex = 0;
            let nearestDistance = Infinity;

            items.forEach((item, index) => {
              const distance = Math.abs(item.offsetLeft - track.offsetLeft - scrollLeft);
              if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
              }
            });

            currentIndex = nearestIndex;
            updateButtons();
          });
        },
        { passive: true }
      );

      window.addEventListener('resize', updateButtons, { passive: true });
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rabitat-search"]) return;
  try {
    
  (function () {
    function initSearchPage(root) {
      if (!root || root.dataset.searchPageBound === 'true') return;
      root.dataset.searchPageBound = 'true';

      var input = root.querySelector('[data-search-page-input]');
      var clearBtn = root.querySelector('[data-search-page-clear]');
      if (!input) return;

      function updateClearButton() {
        if (!clearBtn) return;
        clearBtn.hidden = input.value.trim().length === 0;
      }

      input.addEventListener('input', updateClearButton);

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          updateClearButton();
          input.focus();
        });
      }

      if (!input.value.trim()) {
        input.focus();
      }
    }

    document.querySelectorAll('[data-rabitat-search-page]').forEach(initSearchPage);
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-rabitat-search-page]');
      if (root) initSearchPage(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
